import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  CatalogItem 
} from "utility/constants";

export interface CloudServicesState {
  data: CatalogItem[];
  loading: boolean;
  error: string | null;
  fetched: boolean;
  fetchAttempted: boolean;
}

const initialState: CloudServicesState = {
  data: [],
  loading: false,
  error: null,
  fetched: false,
  fetchAttempted: false,
};

const cloudServicesSlice = createSlice({
  name: 'cloudServices',
  initialState,
  reducers: {
    fetchCloudServicesRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.fetchAttempted = true;
    },
    fetchCloudServicesSuccess: (state, action: PayloadAction<CatalogItem[]>) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
      state.fetched = true;
      state.fetchAttempted = true;
    },
    fetchCloudServicesFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.fetched = false;
      state.fetchAttempted = true; 
    },
    resetCloudServices: (state) => {
      state.data = [];
      state.loading = false;
      state.error = null;
      state.fetched = false;
      state.fetchAttempted = false;
    },
  },
});

export const {
  fetchCloudServicesRequest,
  fetchCloudServicesSuccess,
  fetchCloudServicesFailure,
  resetCloudServices,
} = cloudServicesSlice.actions;

export default cloudServicesSlice.reducer;